import React from "react";
import { Modal, Button, Table } from "react-bootstrap";

const ViewDeletionRequestModal = ({ show, handleClose, deletionRequest }) => {
    if (!deletionRequest) return null; // Prevents rendering if deletionRequest is null

    const isProject = deletionRequest.resource_type === "App\\Models\\Project";
    const isUnit = deletionRequest.resource_type === "App\\Models\\Unit";
    const isPaymentPlan = deletionRequest.resource_type === "App\\Models\\PaymentPlan";
    const resource = deletionRequest.resource || {}; // Resource being deleted
    const user = deletionRequest.user || {}; // Requester details
    const developer = user.developer || {}; // Developer details

    return (
        <Modal show={show} onHide={handleClose} centered size="lg">
            <Modal.Header closeButton>
                <Modal.Title>Deletion Request</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <h5>Requested By</h5>
                <Table striped bordered hover responsive>
                    <tbody>
                        <tr>
                            <td><strong>Name</strong></td>
                            <td>{user.name || "N/A"}</td>
                        </tr>
                        <tr>
                            <td><strong>Email</strong></td>
                            <td>{user.email || "N/A"}</td>
                        </tr>
                        <tr>
                            <td><strong>Developer</strong></td>
                            <td>{developer.name || "N/A"}</td>
                        </tr>
                    </tbody>
                </Table>

                <h5>Resource Details</h5>
                <Table striped bordered hover responsive>
                    <tbody>
                 
                        {isProject ? (
                            <>
                                   <tr>
                            <td><strong>Name</strong></td>
                            <td>{resource.name || "N/A"}</td>
                        </tr>
                                <tr>
                                    <td><strong>Commission (%)</strong></td>
                                    <td>{resource.projectCommission || "N/A"}</td>
                                </tr>
                                <tr>
                                    <td><strong>Starting Price</strong></td>
                                    <td>{resource.startingPrice || "N/A"}</td>
                                </tr>
                            </>
                        ) : isUnit ? (
                            <>
                                   <tr>
                            <td><strong>Name</strong></td>
                            <td>{resource.name || "N/A"}</td>
                        </tr>
                                <tr>
                                    <td><strong>Type</strong></td>
                                    <td>{resource.type || "N/A"}</td>
                                </tr>
                                <tr>
                                    <td><strong>Bedrooms</strong></td>
                                    <td>{resource.numberOfBedrooms || "N/A"}</td>
                                </tr>
                                <tr>
                                    <td><strong>Bathrooms</strong></td>
                                    <td>{resource.numberOfBathrooms || "N/A"}</td>
                                </tr>
                            </>
                        ): isPaymentPlan ? (
                            <>
                              <tr>
                                    <td><strong>Payment Plan Name</strong></td>
                                    <td>{resource.name || "N/A"}</td>
                                </tr>
                                <tr>
                                    <td><strong>Number of Installments</strong></td>
                                    <td>{resource.installments || "N/A"}</td>
                                </tr>
                                <tr>
                                    <td><strong>Downpayment</strong></td>
                                    <td>{resource.downpayment || "N/A"}</td>
                                </tr>
                            </>
                        )
                    : (<></>)
                    
                    }
                    </tbody>
                </Table>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ViewDeletionRequestModal;
